/**
 * Parcels Details
 */

// React
import React, { useState, useEffect } from 'react';

//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  Typography,
  Paper,
  Grid,
  Button,
  Divider,
  CircularProgress,
  TextField
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiWarehouse,
  mdiArrowRight,
  mdiPackage,
  mdiPhoneOutline,
  mdiCalendar,
  mdiCalendarClock,
  mdiMapMarkerOutline,
  mdiPrinter,
} from '@mdi/js';

// Components
import ListParcelItems from './list';

// Rules

// Helper
import { formaterPhoneNumber } from '../../utils/helpers';
import jMoment from 'moment-jalaali';

// Type
import { Props } from './interfaces';
import handleError from '../../utils/handleError';
import parcelsRepository from 'client-sdk/src/Repository/parcels-repository';
import { Link } from 'react-router-dom';
import handleNotfication from '../../utils/handleNotfication';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(0),
        },
      },
    },
    paper: {
      marginTop: '36px',
      marginBottom: '36px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },

    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    divider: {
      width: '98%',
      margin: '10px auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
  })
);

export function PickupsDetails(props: Props) {
  const { id } = props.match.params
  const [parcelDeliveryCost, setParcelDeliveryCost] = useState<string>();
  const [parcel, setParcel] = useState(null);
  const [loading, setLoading] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    getParcel(id);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getParcel = async (id: number) => {
    const payload = { id }
    try {
      setLoading(true)
      const parcel = await parcelsRepository.getParcelsWithId({ payload })
      setParcel(parcel?.data)
      setLoading(false)
    } catch (err) {
      handleError(err)
    }
  }

  const handleChangeDeliveryCost = (e: React.ChangeEvent<HTMLInputElement>) => {
    setParcelDeliveryCost(+e.target?.value);
  };

  const submitParcelDeliveryCost = async () => {
    try {
      await parcelsRepository.updateDeliveryCost({ payload: { id, body: parcelDeliveryCost } })
      setParcelDeliveryCost("")
      getParcel(id)
      handleNotfication('هزینه ارسال با موفقیت ثبت شد', 'success');
    } catch (err) {
      handleNotfication(
        'هزینه ارسال ثبت نشد',
        'error'
      );
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.headerBox}>
        <Typography variant="h6" component="h2">
          {`
        جزيیات محموله 
        ${parcel?.id}`}
        </Typography>
      </div>

      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Button
          aria-label="details"
          size="medium"
          onClick={() => window.history.back()}
        >
          <Icon path={mdiArrowRight} size={1} className={classes.icon} />
          {`بازگشت`}
        </Button>
        <Link to={`/pickups/details/receipt/${id}`} target="_blank">
          <Button
            aria-label="details"
            size="medium"
            variant='contained'
            color='secondary'
          >
            <Icon path={mdiPrinter} size={1} className={classes.icon} />
            {`پرینت`}
          </Button>
        </Link>
      </Grid>
      <Paper elevation={3} className={classes.paper} variant="elevation" square>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiWarehouse} size={1} className={classes.icon} />
                {`نام شرکت:  `}
              </span>

              <span>{parcel?.partnerName}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCalendar} size={1} className={classes.icon} />
                {`تاریخ جمع‌آوری:  `}
              </span>
              <span>
                <span>
                  {parcel?.ronadTransportationDTO &&
                    `${jMoment(
                      parcel?.ronadTransportationDTO?.pickDate,
                      'YYYY/MM/DD'
                    )
                      .locale('fa')
                      .format('jYYYY/jMM/jDD')}`}
                </span>
              </span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiCalendarClock}
                  size={1}
                  className={classes.icon}
                />
                {`ساعت جمع‌آوری:  `}
              </span>
              <span>
                <span>
                  {parcel?.ronadTransportationDTO &&
                    jMoment(
                      parcel?.ronadTransportationDTO?.pickTime,
                      'hh:mm'
                    )
                      .locale('fa')
                      .format('HH:mm')}
                </span>
              </span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiPackage} size={1} className={classes.icon} />
                {`تعداد بسته:  `}
              </span>

              <div>
                {parcel?.parcelPackages.map(el => <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <span className='ml-1'>{el?.count}</span>
                  <span className='ml-1'>{`${el.length}×${el.height}×${el.width}`}</span>
                  <span>{el.weight}</span>
                </div>)}
              </div>
            </div>
          </Grid>
          <Divider className={classes.divider} />
          <Grid item xs={12}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiMapMarkerOutline}
                  size={1}
                  className={classes.icon}
                />
                {`آدرس محل جمع‌آوری :  `}
              </span>
              <span>{parcel?.ronadTransportationDTO?.pickAddress}</span>
            </div>
          </Grid>
          <Divider className={classes.divider} />
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiWarehouse} size={1} className={classes.icon} />
                {`نام انبار مقصد:  `}
              </span>

              <span>{parcel?.destinationName}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCalendar} size={1} className={classes.icon} />
                {`تاریخ تحویل به انبار:  `}
              </span>
              <span>
                <span>
                  {parcel?.shippingDate &&
                    `${jMoment(parcel?.deliveryDate, 'YYYY/MM/DD')
                      .locale('fa')
                      .format('jYYYY/jMM/jDD')}`}
                </span>
              </span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiPhoneOutline}
                  size={1}
                  className={classes.icon}
                />
                {`تلفن انبار مقصد:  `}
              </span>
              <span>
                {formaterPhoneNumber(parcel?.destinationPhoneNumber)}
              </span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiPhoneOutline}
                  size={1}
                  className={classes.icon}
                />
                {`شماره تماس اجینت:  `}
              </span>
              <span>{parcel?.agentPhoneNumber}</span>
            </div>
          </Grid>
          <Divider className={classes.divider} />
          <Grid item xs={12} sm={4}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiMapMarkerOutline}
                  size={1}
                  className={classes.icon}
                />
                {`آدرس محل تخلیه :  `}
              </span>
              <span>{parcel?.destinationAddress}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={4}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiPackage}
                  size={1}
                  className={classes.icon}
                />
                {`توضیحات :  `}
              </span>
              <span>{parcel?.description}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={4}>
            <div className={classes.item}>
              <span>{parcel?.deliveryCost}</span>
              <span style={{ marginRight: '5px', marginLeft: '15px' }}>{"ریال"}</span>
              <TextField
                id="outlined-basic"
                value={parcelDeliveryCost}
                onChange={handleChangeDeliveryCost}
                size={'small'}
                variant="outlined"
                placeholder='هزینه ارسال(ریال):'
                fullWidth
              />
              <Button
                style={{ marginRight: '5px' }}
                variant="contained"
                color="secondary"
                onClick={submitParcelDeliveryCost}
                size={'medium'}
              >{`ثبت`}</Button>
            </div>
          </Grid>
        </Grid>
      </Paper>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {loading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            parcel?.items && <ListParcelItems data={parcel?.items} />
          )}
        </Grid>
      </Grid>
    </div>
  );
}

export default PickupsDetails;
